import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import ReactApexChart from 'react-apexcharts';
import { useHistory } from 'react-router-dom';

// chart options
const barChartOptions = {
    chart: {
        type: 'bar',
        height: 350
    },
    plotOptions: {
        bar: {
            borderRadius: 4,
            horizontal: true
        }
    },
    dataLabels: {
        enabled: false
    }
};

const ApexBarChart = ({ category, data, roleTypes, selectedBolge, selectedServis }) => {
    const theme = useTheme();
    const history = useHistory();  // useHistory hook'unu ekleyin

    const { primary } = theme.palette.text;
    const darkLight = theme.palette.dark.light;
    const grey200 = theme.palette.grey[200];
    const successDark = theme.palette.success.dark;

    const [series, setSeries] = useState([]);
    const [options, setOptions] = useState(barChartOptions);

    useEffect(() => {
        setOptions((prevState) => ({
            ...prevState,
            colors: ['#FF9800'],
            xaxis: {
                categories: category,
                labels: {
                    style: {
                        colors: new Array(category.length).fill(primary)
                    }
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: new Array(data[0].data.length).fill(primary)
                    }
                }
            },
            grid: {
                borderColor: theme.palette.mode === 'dark' ? darkLight + 20 : grey200
            },
            tooltip: {
                theme: theme.palette.mode === 'dark' ? 'dark' : 'light'
            },
            chart: {
                events: {
                    dataPointSelection: (event, chartContext, config) => {
                        const selectedEmployeeType = category[config.dataPointIndex];
                        if (roleTypes === true) {
                            const redirectUrl = `/EmployeeMain/1?selectedBolge=${selectedBolge}&selectedServis=${selectedServis}&selectedEmployeeType=${selectedEmployeeType}`;
                            history.push(redirectUrl);  // Redirect yerine history.push kullanın
                        } else {
                            const redirectUrl = `/Employee`;
                            history.push(redirectUrl);  // Redirect yerine history.push kullanın
                        }
                    },
                    dataPointMouseEnter: (event, chartContext, config) => {
                        event.target.style.cursor = 'pointer';
                    },
                }
            }


        }));
        setSeries(data);
    }, [category, data, primary, darkLight, grey200, successDark, theme.palette.mode, history, roleTypes, selectedBolge, selectedServis]);

    return (
        <div id="chart">
            <ReactApexChart options={options} series={series} type="bar" height={350} />
        </div>
    );
};

export default ApexBarChart;
